import { Controller } from '@hotwired/stimulus'

// Expands/collapses grid tiles hidden beyond the initial visible count
// (catalog index category sections). Toggle button label switches between
// the provided more/less texts.
export default class extends Controller {
  static targets = ['item', 'label']
  static values = { moreText: String, lessText: String }

  toggle() {
    const expand = this.itemTargets[0].classList.contains('hidden')
    this.itemTargets.forEach((el) => el.classList.toggle('hidden', !expand))
    this.labelTarget.textContent = expand ? this.lessTextValue : this.moreTextValue
  }
}
